import { defineMessages } from 'react-intl';

const cashstarLogoMessages = defineMessages({
    cashstarLogoAlt: {
        id: 'footer.cashstarLogoMessages.cashstarLogoAlt',
        description: 'Alt text for CashStar logo image',
        defaultMessage: 'CashStar, A Blackhawk Network Business'
    }
});

export default cashstarLogoMessages;
